// extracted by mini-css-extract-plugin
module.exports = {"EuEcoCredits":"CommonElement_EuEcoCredits__TN0xC","JpEcoCredits":"CommonElement_JpEcoCredits__h5CEr"};